export default __webpack_public_path__ + "static/media/Feautured_3.424e2f9b.png";